import { ISubPrice } from "src/models/ISubPrice";

export class SubPrice implements ISubPrice {
    // host_id = 0;
    location = "";
    price = 0;
    currency = 'USD';
    isDefault = true;
    sub_location_id = 0;
}